import {axiosApiCallWithToken} from "../axios/customInstance";


export const getActivePatientsCount = async () => {
    const url = "/countActivePatients";

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};


export const getDrugAssumptionNotificationsByUserId = async (userId) => {
    const url = "/getDrugAssumptionNotifications/user?userId=" + userId

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
}


export const getPatientEducationalNotificationsByUserId = async (userId) => {
    const url = "/getEducationalNotifications/user?userId=" + userId

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
}


export const getBloodTestsByUserId = async (userId) => {
    const url = "/getBloodTests/user?userId=" + userId

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
}


export const getBloodTestsDatesByUserId = async (userId) => {
    const url = "/getBloodTestsDates/user?userId=" + userId

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
}